import * as React from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import { TextField, Button, Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Users, Wallet, Clock } from "lucide-react";
import { FileText, Printer, Download, Eye } from "lucide-react";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  FormControlLabel,
  Checkbox,
  Switch,
  RadioGroup,
  Radio,
} from "@mui/material";
import AccountSelector from "./AccountSelector";
import Group1Selector from "./Group1Selector";
import Group2Selector from "./Group2Selector";
import { useEffect } from "react";
import axios from "axios";
import { StatementPDFButton } from "./StatementPDF";
import { useNavigate } from "react-router-dom";
import StatementPreview from "./StatementPreview";
import OutstandingPreview from "./OutstandingPreview";
import StatementAgeingPreview from "./StatementAgeingPreview";

export default function StatementPanel({
  onStatementDataFetched,
  onOutstandingStatementDataFetched,
  onAgeingStatementDataFetched,
  isGroup,
  setIsGroup,
  initialAccountData,
}) {
  const [isCallingViewPDFAPI, setIsCallingViewPDFAPI] = useState(false);
  const [isCallingDownloadPDFAPI, setIsCallingDownloadPDFAPI] = useState(false);

  const [isCallingViewPDFAPIOutstanding, setIsCallingViewPDFAPIOutstanding] = useState(false);
  const [isCallingDownloadPDFAPIOutstanding, setIsCallingDownloadPDFAPIOutstanding] = useState(false);

  const [expanded, setExpanded] = useState("panel1");
  const [value, setValue] = useState("ALL");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [fromDate, setFromDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [systemFromDate, setSystemFromDate] = useState(
    dayjs().format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [systemToDate, setSystemToDate] = useState(
    dayjs().format("YYYY-MM-DD")
  );

  const [jobCodeChecked, setJobCodeChecked] = useState(false);
  const [deptCode, setDeptCode] = useState("-");
  const [salesperson, setSalesperson] = useState("-");
  const [isOpen, setIsOpen] = useState(false);

  const inputStyle = {
    borderRadius: "50px",
    border: "1px solid #e5e7eb",
    padding: "8px 40px 8px 16px",
    outline: "none",
    fontSize: "16px",
    backgroundColor: "white",
    width: "180px",
  };

  const wrapperStyle = {
    position: "relative",
    display: "inline-block",
    // marginRight: "8px",
  };

  const iconStyle = {
    position: "absolute",
    right: "32px",
    top: "50%",
    // transform: "translateY(-50%)",
    pointerEvents: "none",
    color: "#9ca3af",
  };

  // const [isGroup, setIsGroup] = useState(false);

  // const [isGroupOutstanding, setIsGroupOutstanding] = useState(false);
  // const [isGroupAgeing, setIsGroupAgeing] = useState(false);
  const [accountListFromAPI, setAccountListFromAPI] = useState(null);
  const [searchTerm, setSearchTerm] = useState("-");
  const [selectedAccountToAPI, setSelectedAccountToAPI] = useState("-");
  const [selectedAccountNameToAPI, setSelectedAccountNameToAPI] = useState("-");
  const [selectedAccountPhoneToAPI, setSelectedAccountPhoneToAPI] =
    useState("-");
  const [selectedAccount2ToAPI, setSelectedAccount2ToAPI] = useState("-");
  const [statementToAPI, setStatementToAPI] = useState("STMT_ACC1");
  const [outStatementToAPI, setOutStatementToAPI] = useState("OUT_ACC1");
  const [ageingStatementToAPI, setAgeingStatementToAPI] = useState("AGE_ACC1");
  // const [statementToAPI, setStatementToAPI] = useState("-");
  // const [outStatementToAPI, setOutStatementToAPI] = useState("-");
  // const [ageingStatementToAPI, setAgeingStatementToAPI] = useState("-");
  const [checkedState, setCheckedState] = useState({});
  const [outstandingCheckedState, setOutstandingCheckedState] = useState({});
  const [ageingCheckedState, setAgeingCheckedState] = useState({});
  const [isSummary, setIsSummary] = useState(true);
  const [isDetails, setIsDetails] = useState(false);
  const [accountsAll, setAccountsAll] = useState(false);
  const [accountsDebit, setAccountsDebit] = useState(false);
  const [accountsCredit, setAccountsCredit] = useState(false);
  const [ageingShowDisabled, setAgeingShowDisabled] = useState(false);
  const [departmentList, setDepartmentList] = useState([]);
  const [salesPersonList, setSalesPersonList] = useState([]);


  // Common checkboxes except "Group Summary"
  const commonCheckboxes = [
    "Exclude opening",
    "Consolidate",
    "Show PDC",
    "Enable filter dropdown",
    "Grid Export",
  ];

  const outstandingCheckboxes = [
    "Period",
    "As of date",
    "Salesperson",
    "Include PDC",
    "Enable filter dropdown",
    "Grid Export",
  ];

  const ageingCheckboxes = ["Monthwise", "ON A/C", "Open Dt", "With PDC"];

  // If group is ON, add "Group Summary"
  const checkboxList = isGroup
    ? [...commonCheckboxes, "Group Summary"]
    : commonCheckboxes;

  // const outstandingCheckboxList = isGroup
  //   ? [...outstandingCheckboxes, "Group Summary"]
  //   : outstandingCheckboxes;

  const outstandingCheckboxList = outstandingCheckboxes;
  const ageingCheckboxList = ageingCheckboxes;

  const handleCheckboxChange = (label, checked) => {
    setCheckedState((prev) => {
      const updated = { ...prev, [label]: checked };

      // Define the logic for determining the API endpoint
      const getAPIEndpoint = (state) => {
        const {
          "Exclude opening": excludeOpening,
          Consolidate: consolidate,
          "Show PDC": showPDC,
          "Enable filter dropdown": enableFilter,
          "Grid Export": gridExport,
          "Group Summary": groupSummary,
        } = state;

        // Priority-based logic for determining endpoint

        // Group Mode Handling
        if (isGroup) {
          if (excludeOpening) {
            return "STMT_GRP2"; // Group with Exclude Opening
          }
          return "STMT_GRP1"; // Group without Exclude Opening
        } else if (
          selectedAccountToAPI === "-" &&
          selectedAccount2ToAPI !== "-"
        ) {
          if (excludeOpening) {
            return "STMT_GRP2"; // Group with Exclude Opening
          }
          return "STMT_GRP1"; // Group without Exclude Opening
        }

        // Account Mode Handling
        // If "Exclude opening" is selected, always use STMT_ACC2 (highest priority)
        // if (accountsAll===true){

        if (excludeOpening) {
          return "STMT_ACC2";
        }
        // If "Consolidate" is selected (without Exclude opening)
        if (consolidate) {
          // If also has "Show PDC", use STMT_ACC3
          if (showPDC) {
            return "STMT_ACC3";
          }
          // If only "Consolidate" with other options (but no Show PDC), use STMT_CONS
          return "STMT_CONS";
        }

        // If "Show PDC" is selected (without Exclude opening or Consolidate)
        if (showPDC) {
          return "STMT_ACC3";
        }

        // }else if(accountsDebit===true){

        if (excludeOpening) {
          return "STMT_ACC2";
        }
        // If "Consolidate" is selected (without Exclude opening)
        if (consolidate) {
          // If also has "Show PDC", use STMT_ACC3
          if (showPDC) {
            return "STMT_ACC3";
          }
          // If only "Consolidate" with other options (but no Show PDC), use STMT_CONS
          return "STMT_CONS";
        }

        // If "Show PDC" is selected (without Exclude opening or Consolidate)
        if (showPDC) {
          return "STMT_ACC3";
        }

        // }else if(accountsCredit===true){

        if (excludeOpening) {
          return "STMT_ACC2";
        }
        // If "Consolidate" is selected (without Exclude opening)
        if (consolidate) {
          // If also has "Show PDC", use STMT_ACC3
          if (showPDC) {
            return "STMT_ACC3";
          }
          // If only "Consolidate" with other options (but no Show PDC), use STMT_CONS
          return "STMT_CONS";
        }

        // If "Show PDC" is selected (without Exclude opening or Consolidate)
        if (showPDC) {
          return "STMT_ACC3";
        }
        // }

        // For all other cases (Enable filter dropdown, Grid Export, Group Summary, or none)
        return isGroup ? "STMT_GRP1" : "STMT_ACC1";
      };

      // Set the API endpoint based on the current state
      setStatementToAPI(getAPIEndpoint(updated));

      return updated;
    });
  };

  const handleOutstandingCheckboxChange = (label, checked) => {
    setOutstandingCheckedState((prev) => {
      const updated = { ...prev, [label]: checked };

      // Define the logic for determining the API endpoint
      const getAPIEndpoint = (state) => {
        const {
          "Include PDC": includePDC,
          Period: period,
          "As of date": asOfDate,
          Salesperson: salesperson,
          "Enable filter dropdown": enableFilter,
          "Grid Export": gridExport,
        } = state;

        // Priority-based logic for determining endpoint

        // If "As of date" is selected, use OUT_ACC7
        if (isGroup) {
          if (period) {
            return "OUT_GRP1_PERIOD";
          }
          return "OUT_GRP1"; // Group without Exclude Opening
        }

        if (asOfDate) {
          return "OUT_ACC7";
        }

        // If "Include PDC" is selected
        if (includePDC) {
          // If also has "Period", use OUT_ACC2
          if (period) {
            return "OUT_ACC2";
          }
          // If only "Include PDC" with other options (but no Period), use OUT_ACC2
          return "OUT_ACC2";
        }

        // If "Period" is selected (without Include PDC or As of date)
        if (period) {
          return "OUT_ACC3";
        }

        // For all other cases (Salesperson, Enable filter dropdown, Grid Export, or none)
        return isGroup ? "OUT_GRP1" : "OUT_ACC1";
      };

      // Set the API endpoint based on the current state
      setOutStatementToAPI(getAPIEndpoint(updated));

      return updated;
    });
  };

  const handleAgeingModChange = (event) => {
    if (isGroup) {
      if (event.target.value === "summary") {
        setIsDetails(false);
        setIsSummary(true);
        setAgeingStatementToAPI("AGE_GRP1");
      } else if (event.target.value === "details") {
        setIsSummary(false);
        setIsDetails(true);
        setAgeingStatementToAPI("AGE_GRP2");
      }
    } else {
      if (event.target.value === "summary") {
        setAgeingStatementToAPI("AGE_ACC1");
      } else if (event.target.value === "details") {
        setAgeingStatementToAPI("AGE_ACC2");
      }
    }
  };

  const handleAgeingCheckboxChange = (label, checked) => {
    setAgeingCheckedState((prev) => {
      const updated = { ...prev, [label]: checked };

      const getAPIEndpoint = (state) => {
        const {
          Monthwise: monthwise,
          "ON A/C": onAC,
          "Open Dt": openDt,
          "With PDC": withPDC,
        } = state;

        // 🔹 Priority-based logic
        if (
          isGroup &&
          selectedAccountToAPI?.trim() !== "-" &&
          selectedAccount2ToAPI?.trim() === "-"
        ) {
          if (isSummary === true) {
            if (monthwise) {
              return "MONTH_GRP";
            }

            if (onAC) {
              if (openDt) {
                return "AGE_GRP10";
              } else if (withPDC) {
                return "AGEPDC_GRP";
              }
              return "AGE_GRP1";
            }

            if (openDt) {
              return "AGE_GRP10";
            }

            if (withPDC) {
              return "AGEPDC_GRP";
            }
            return "AGE_GRP1"; // Default Group summary
          } else if (isDetails === true) {
            if (monthwise) {
              return "MONTH_GRP";
            }

            if (onAC) {
              if (openDt) {
                return "AGE_GRP10";
              } else if (withPDC) {
                return "AGE_GRP2";
              }
              return "AGE_GRP2";
            }

            if (openDt) {
              return "AGE_GRP10";
            }

            if (withPDC) {
              return "AGE_GRP2";
            }
            return "AGE_GRP2";
          }
        } else if (
          isGroup &&
          selectedAccountToAPI?.trim() !== "-" &&
          selectedAccount2ToAPI?.trim() !== "-"
        ) {
          if (isSummary === true) {
            if (monthwise) {
              return "MONTH_GRP";
            }

            if (onAC) {
              if (openDt) {
                if (withPDC) {
                  return "AGE_GRP4";
                }
                return "AGE_GRP4";
              } else if (withPDC) {
                return "AGE_GRP4";
              }
              return "AGE_GRP4";
            }

            if (openDt) {
              return "AGE_GRP3";
            }

            if (withPDC) {
              return "AGE_GRP3";
            }
            return "AGE_GRP3"; // Default Group summary
          } else if (isDetails === true) {
            if (monthwise) {
              return "MONTH_GRP";
            }

            if (onAC) {
              if (openDt) {
                return "AGE_GRP4";
              } else if (withPDC) {
                return "AGE_GRP4";
              }
              return "AGE_GRP4";
            }

            if (openDt) {
              return "AGE_GRP3";
            }

            if (withPDC) {
              return "AGE_GRP3";
            }
            return "AGE_GRP3";
          }
        } else if (
          isGroup &&
          selectedAccountToAPI?.trim() === "-" &&
          selectedAccount2ToAPI?.trim() !== "-"
        ) {
          if (isSummary === true) {
            if (monthwise) {
              return "MONTH_GRP";
            }

            if (onAC) {
              if (openDt) {
                if (withPDC) {
                  return "AGE_GRP4";
                }
                return "AGE_GRP4";
              } else if (withPDC) {
                return "AGE_GRP4";
              }
              return "AGE_GRP4";
            }

            if (openDt) {
              return "AGE_GRP3";
            }

            if (withPDC) {
              return "AGE_GRP3";
            }
            return "AGE_GRP3"; // Default Group summary
          } else if (isDetails === true) {
            if (monthwise) {
              return "MONTH_GRP";
            }

            if (onAC) {
              if (openDt) {
                return "AGE_GRP4";
              } else if (withPDC) {
                return "AGE_GRP4";
              }
              return "AGE_GRP4";
            }

            if (openDt) {
              return "AGE_GRP3";
            }

            if (withPDC) {
              return "AGE_GRP3";
            }
            return "AGE_GRP3";
          }
        } else {
          if (monthwise) {
            return "AGE_ACC3"; // Example: Account + Monthwise
          }
          if (onAC) {
            return "AGE_ACC4"; // Example: Account + ON A/C
          }
          if (openDt) {
            return "AGE_ACC5"; // Example: Account + Open Date
          }
          if (withPDC) {
            return "AGE_ACC6"; // Example: Account + With PDC
          }
          return "AGE_ACC1"; // Default Account summary
        }
      };

      setAgeingStatementToAPI(getAPIEndpoint(updated));
      return updated;
    });
  };

  useEffect(() => {
    //fetchAccountList();
    fetchCompanyInfo();
    callSalesPersonListAPI();
    fetchDepartments();
  }, []);

  useEffect(() => {
    setValue(value);
    //fetchAccountList();
  }, [value]);

  useEffect(() => {
    if (isGroup) {
      setAgeingStatementToAPI("AGE_GRP1");
    } else {
      setAgeingStatementToAPI("AGE_ACC1");
    }
    setSelectedAccountToAPI("-");
    setSelectedAccount2ToAPI("-");
    onShowStatement();
    console.log("ageingStatementToAPI:", ageingStatementToAPI);
  }, [isGroup]);

  // https://cubixweberp.com:213/api/CRMAgeing/SUNRISEWEB/AGE_GRP1/1205/-/-/2024-01-01/2026-12-31/30/60/90/120/130/-/-

  useEffect(() => {
    // if (!selectedAccountToAPI && !selectedAccount2ToAPI) return;
    // selectedAccountToAPI
    console.log(
      "🚀 ~ StatementPanel ~ selectedAccountToAPI:",
      selectedAccountToAPI
    );
    console.log("🚀 ~ searchTerm ~ searchTerm:", searchTerm);

    if (selectedAccountToAPI) {
      // setStatementToAPI('STMT_ACC1')
      // setOutStatementToAPI('OUT_ACC1')
      // setAgeingStatementToAPI('AGE_ACC1')
      onShowStatement();
    }
  }, [
    selectedAccountToAPI,
    selectedAccount2ToAPI,
    fromDate,
    toDate,
    searchTerm,
  ]);

  useEffect(() => {
    if (initialAccountData && initialAccountData.ACCOUNT) {
      console.log("Auto-filling account from navigation:", initialAccountData);
      const accountCode = initialAccountData.ACCOUNT;

      // Set the selected account
      setSelectedAccountToAPI(accountCode);

      // Auto-fetch the statement after a brief delay
      // setTimeout(() => {
      //   fetchStatementForInitialAccount(accountCode);
      // }, 500);
    }
  }, [initialAccountData]);

  const callSalesPersonListAPI = () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";
    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    const currentDepartmentFromLocalStorage = localStorage.getItem(
      "currentSelectedDepartment"
    );
    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterCount/${company_code_from_local_storage}/SALESPERSONLIST/-/${currentDepartmentFromLocalStorage}`;
    axios
      .get(apiUrl)
      .then((res) => {
        setSalesPersonList(res.data);
      })
      .catch((err) => { });
  };

  const fetchDepartments = async () => {
    try {
      let company_code_from_local_storage = localStorage.getItem("companyCode")
        ? localStorage.getItem("companyCode")
        : "-";

      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;

      const apiURL = `${apiBaseURL}/api/CpaysCount/${company_code_from_local_storage}/DEPTLIST/-/-`;
      const response = await axios.get(apiURL);
      const data = response.data;
      console.log("Dept List:", data);
      setDepartmentList(data);
    } catch (error) {
      console.error("Error while fetching Dept list!", error);
    }
  };

  const selectedAccountFromChild = (acc) => {
    const accountSelected = acc?.trim();
    console.log("selectedAccountFromChild accountSelected::", accountSelected);
    setSelectedAccountToAPI(accountSelected);
  };

  const selectedAccountNameFromChild = (acc) => {
    const accountNameSelected = acc?.trim();
    console.log(
      "selectedAccountNameFromChild accountNameSelected::",
      accountNameSelected
    );
    setSelectedAccountNameToAPI(accountNameSelected);
  };

  const selectedAccountPhoneFromChild = (acc) => {
    const accountPhoneSelected = acc?.trim();
    console.log(
      "selectedAccountPhoneFromChild accountPhoneSelected::",
      accountPhoneSelected
    );
    setSelectedAccountPhoneToAPI(accountPhoneSelected);
  };

  const selectedGroup1FromChild = (acc) => {
    console.log("selectedGroup1FromChild acc:", acc);
    const group1Selected = acc?.trim();
    setSelectedAccountToAPI(group1Selected);
    // setSelectedAccountToAPI(acc);
  };

  const selectedGroup2FromChild = (acc) => {
    console.log("selectedGroup2FromChild acc:", acc);
    const group2Selected = acc.trim();
    setSelectedAccount2ToAPI(group2Selected);
    // setSelectedAccount2ToAPI(acc);
  };

  const fetchAccountList = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment"
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMAccountList/${company_code_from_local_storage}/ACCOUNTLIST/${currentSelectedDepartment}/${value}/-/-`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      // console.log("fetched Account List :", data);
      setAccountListFromAPI(data);
    } catch (err) {
      console.error("Error while fetching jobist", err);
    }
  };

  const fetchCompanyInfo = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment"
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${company_code_from_local_storage}/COMPANYINFO/-/-`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      const companyInfoData = data[0];
      console.log("companyInfoData :", companyInfoData);

      if (companyInfoData && companyInfoData.fystart) {
        const parsedFrom = dayjs(companyInfoData.fystart);
        if (parsedFrom.isValid()) setFromDate(parsedFrom.format("YYYY-MM-DD"));
      }

      if (companyInfoData && companyInfoData.ftend) {
        const parsedTo = dayjs(companyInfoData.ftend);
        if (parsedTo.isValid()) setToDate(parsedTo.format("YYYY-MM-DD"));
      }
      setFromDate(dayjs(companyInfoData.fystart).format("YYYY-MM-DD"));
      setSystemFromDate(dayjs(companyInfoData.fystart).format("YYYY-MM-DD"));
      // setToDate(dayjs(companyInfoData.ftend).format("YYYY-MM-DD"));
      setToDate(dayjs().format("YYYY-MM-DD"));
      setSystemToDate(dayjs(companyInfoData.fystart).format("YYYY-MM-DD"));
    } catch (err) {
      console.error("Error while fetching companny Info", err);
    }
  };

  const navigate = useNavigate();

  const onDownloadPDFAccountStatement = async () => {
    console.log("onDownloadPDFAccountStatement: called!");

    let company_code_from_local_storage =
      localStorage.getItem("companyCode") || "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : [];

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMStatementPdf/${company_code_from_local_storage}/${statementToAPI}/${selectedAccountToAPI}/${selectedAccount2ToAPI}/-/${fromDate}/${toDate}/-/-/STATEMENT`;

    try {
      const response = await axios.get(apiUrl, {
        responseType: "blob",
      });

      // Create blob
      const blob = new Blob([response.data], { type: "application/pdf" });

      // Create download URL
      const url = window.URL.createObjectURL(blob);

      // Create temporary link
      const link = document.createElement("a");
      link.href = url;
      link.download = "Account_Statement.pdf"; // file name

      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);

      console.log("PDF downloaded successfully");
    } catch (err) {
      console.error("Error onDownloadPDFAccountStatement:", err);
      alert("Error while downloading PDF");
    }
  };

  const onPrintAccountStatement = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    console.log("onPrintAccountStatement is clicked");
    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMStatement/${company_code_from_local_storage}/${statementToAPI}/${selectedAccountToAPI}/${selectedAccount2ToAPI}/-/${fromDate}/${toDate}/-/-`;
    console.log("Statement data: ", apiUrl)
    try {
      const response = await axios.get(apiUrl);
      const apiData = response.data;
      console.log("get apiData:", apiData);
      const data = {
        selectedAccountToAPI: selectedAccountToAPI,
        selectedAccountNameToAPI: selectedAccountNameToAPI,
        selectedAccountPhoneToAPI: selectedAccountPhoneToAPI,
        apiData: apiData,
        fromDate: fromDate,
        toDate: toDate,
      };
      // navigate("/statementDocument", { state: { statementData: data } });
      console.log("get statement on print:", data);
      handleOpenStatement(data);
    } catch (err) {
      console.error("Error while getting statement:", err);
      alert("Error while printing statement");
    }
  };

  const [showStatementModal, setShowStatementModal] = useState(false);
  const [showOutstandingModal, setShowOutstandingModal] = useState(false);
  const [showStatementAgeingModal, setShowStatementAgeingModal] =
    useState(false);

  // Statement State Variables
  const [statementData, setStatementData] = useState(null);
  const [statementDataRecords, setStatementDataRecords] = useState(null);

  // Outstanding State Variables
  const [outstandingData, setOutstandingData] = useState(null);
  const [outstandingDataRecords, setOutstandingDataRecords] = useState(null);

  // Ageing State Variables
  const [statementAgeingData, setStatementAgeingData] = useState(null);

  const handleOpenStatement = (data) => {
    console.log("handleOpenStatement:", data);
    setStatementData(data);
    setStatementDataRecords(data.apiData);
    setShowStatementModal(true);
  };

  // handleOpenOutstandingStatement
  const handleOpenOutstandingStatement = (data) => {
    console.log("handleOpenOutstandingStatement:", data);
    setOutstandingData(data);
    setOutstandingDataRecords(data.apiData);
    setShowOutstandingModal(true);
  };

  const handleOpenStatementAgeing = (data, ageingStatementToAPI) => {
    console.log("ageingStatementToAPI:", ageingStatementToAPI);
    setStatementAgeingData(data);
    setShowStatementAgeingModal(true);
  };

  const handleCloseStatement = () => {
    setShowStatementModal(false);
    setStatementData(null);
    setStatementDataRecords(null);

    setShowOutstandingModal(false);
    setOutstandingData(null);
    setOutstandingDataRecords(null);

    setShowStatementAgeingModal(false);
  };

  const onShowStatement = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    // let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMStatement/${company_code_from_local_storage}/${statementToAPI}/${selectedAccountToAPI}/${selectedAccount2ToAPI}/-/${fromDate}/${toDate}/-/-`;
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMStatement/${company_code_from_local_storage}/${statementToAPI}/${selectedAccountToAPI}/${selectedAccount2ToAPI}/-/${fromDate}/${toDate}/-/-`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      console.log("get statement:", data);
      onStatementDataFetched(data);
    } catch (err) {
      console.error("Error while getting statement:", err);
    }
  };

  const onShowOutstandingStatement = async () => {
    console.log("Oststanding show clicked");

    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMOutstanding/${company_code_from_local_storage}/${outStatementToAPI}/${selectedAccountToAPI}/${selectedAccount2ToAPI}/-/${fromDate}/${toDate}/-/-`;
    console.log("onShowOutstandingStatement apiUrl:", apiUrl);
    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      console.log("get outstanding statement:", data);
      onOutstandingStatementDataFetched(data);
    } catch (err) {
      console.error("Error while getting outstanding statement:", err);
    }
  };

  const fetchStatementForAccount = async (accountCode) => {
    if (!accountCode) return;
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMStatement/${company_code_from_local_storage}/${statementToAPI}/${accountCode}/${selectedAccount2ToAPI}/-/${fromDate}/${toDate}/-/-`;
    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      console.log("auto-get statement:", accountCode, data);
      setSelectedAccountToAPI(accountCode);
      setSearchTerm(accountCode);
      onStatementDataFetched(data);
    } catch (err) {
      console.error("Error while auto getting statement:", err);
    }
  };

  // initial-account autofill removed — selection is handled by the AccountSelector

  const [intervals, setIntervals] = useState([30, 60, 90, 120, 130]);

  useEffect(() => {
    // Check if any interval is invalid
    const hasInvalid = intervals?.some(
      (interval, index) => index > 0 && interval <= intervals[index - 1]
    );
    setAgeingShowDisabled(hasInvalid);
  }, [intervals]);

  const handleIntervalChange = (index, value) => {
    const numValue = Number(value);

    // Prevent decreasing or invalid numbers
    // if (numValue > (intervals[index - 1] || 0)) {
    const updated = [...intervals];
    updated[index] = numValue;
    setIntervals(updated);
    // }
  };

  // const onPrintOutstandingStatement = async () => {
  //   let company_code_from_local_storage = localStorage.getItem("companyCode")
  //     ? localStorage.getItem("companyCode")
  //     : "-";

  //   console.log("onPrintOutstandingStatement is clicked");
  //   let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
  //     ? JSON.parse(localStorage.getItem("apiPaths"))
  //     : "-";

  //   let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMOutstanding/${company_code_from_local_storage}/${outStatementToAPI}/${selectedAccountToAPI}/${selectedAccount2ToAPI}/-/${fromDate}/${toDate}/-/-`;
  //   try {
  //     const response = await axios.get(apiUrl);
  //     const apiData = response.data;
  //     console.log("get apiData:", apiData);
  //     const data = {
  //       selectedAccountToAPI: selectedAccountToAPI,
  //       apiData: apiData,
  //       fromDate: fromDate,
  //       toDate: toDate,
  //     };
  //     console.log("get outstanding statement on print:", data);
  //     // navigate("/outstandingDocument", {
  //     //   state: {
  //     //     statementData: data,
  //     //     systemFromDate: systemFromDate,
  //     //     systemToDate: systemToDate,
  //     //   },
  //     // });
  //     handleOpenOutstandingStatement(data);
  //   } catch (err) {
  //     console.error("Error while getting outstanding statement:", err);
  //     alert("Error while printing outstanding statement");
  //   }
  // };

  const onPrintOutstandingStatement = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    console.log("onPrintOutstandingStatement is clicked");
    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMOutstanding/${company_code_from_local_storage}/${outStatementToAPI}/${selectedAccountToAPI}/${selectedAccount2ToAPI}/-/${fromDate}/${toDate}/-/-`;

    let agingApiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMOutstanding/${company_code_from_local_storage}/OUT_AGING_ACC/${selectedAccountToAPI}/${selectedAccount2ToAPI}/-/${fromDate}/${toDate}/-/-`;
    console.log("Outtstanding url : ", apiUrl)
    console.log("Aging url : ", agingApiUrl)
    try {
      const [outstandingResponse, agingResponse] = await Promise.all([
        axios.get(apiUrl),
        axios.get(agingApiUrl),
      ]);

      const apiData = outstandingResponse.data;
      const agingData = agingResponse.data;

      console.log("get apiData:", apiData);
      console.log("get agingData:", agingData);

      const data = {
        selectedAccountToAPI: selectedAccountToAPI,
        apiData: apiData,
        agingData: agingData,
        fromDate: fromDate,
        toDate: toDate,
      };

      console.log("get outstanding statement on print:", data);
      handleOpenOutstandingStatement(data);
    } catch (err) {
      console.error("Error while getting outstanding statement:", err);
      alert("Error while printing outstanding statement");
    }
  };

  const onPrintAgeingStatement = async () => {
    console.log("onPrintAgeingStatement is clicked");
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    console.log("onPrintOutstandingStatement is clicked");
    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    const dynamicPart = intervals.join("/");

    // let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMAgeing/${company_code_from_local_storage}/${ageingStatementToAPI}/${selectedAccountToAPI}/-/-/${fromDate}/${toDate}/${dynamicPart}/-/-`;

    let apiUrl = "";
    if (isGroup) {
      // let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMAgeing/${company_code_from_local_storage}/${ageingStatementToAPI}/${selectedAccountToAPI}/-/-/${fromDate}/${toDate}/${dynamicPart}/-/-`;
      // apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMAgeing/${company_code_from_local_storage}/AGE_GRP1/CBM002/1205/-/2024-01-01/2026-12-31/30/60/90/120/130/-/-`;
      apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMAgeing/${company_code_from_local_storage}/${ageingStatementToAPI}/${salesperson}/${selectedAccountToAPI}/-/${fromDate}/${toDate}/${dynamicPart}/-/-`;
    } else {
      apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMAgeing/${company_code_from_local_storage}/${ageingStatementToAPI}/${selectedAccountToAPI}/-/-/${fromDate}/${toDate}/${dynamicPart}/-/-`;
    }

    try {
      const response = await axios.get(apiUrl);
      const apiData = response.data;
      console.log("get apiData:", apiData);
      const data = {
        selectedAccountToAPI: selectedAccountToAPI,
        apiData: apiData,
        fromDate: fromDate,
        toDate: toDate,
      };
      // navigate("/statementDocument", { state: { statementData: data } });
      console.log("get Ageing data on print:", data);
      console.log(
        "get Ageing ageingStatementToAPI on print:",
        ageingStatementToAPI
      );

      handleOpenStatementAgeing(data, ageingStatementToAPI);
    } catch (err) {
      console.error("Error while getting outstanding statement:", err);
      alert("Error while printing outstanding statement");
    }
  };

  const onShowAgeingStatement = async () => {
    console.log("Ageing show clicked");

    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    const dynamicPart = intervals.join("/");
    let apiUrl = "";
    if (isGroup) {
      // let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMAgeing/${company_code_from_local_storage}/${ageingStatementToAPI}/${selectedAccountToAPI}/-/-/${fromDate}/${toDate}/${dynamicPart}/-/-`;
      // apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMAgeing/${company_code_from_local_storage}/AGE_GRP1/CBM002/1205/-/2024-01-01/2026-12-31/30/60/90/120/130/-/-`;
      apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMAgeing/${company_code_from_local_storage}/${ageingStatementToAPI}/${salesperson}/${selectedAccountToAPI}/-/${fromDate}/${toDate}/${dynamicPart}/-/-`;
    } else {
      apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMAgeing/${company_code_from_local_storage}/${ageingStatementToAPI}/${selectedAccountToAPI}/-/-/${fromDate}/${toDate}/${dynamicPart}/-/-`;
    }

    console.log("Generated ageing API URL:", apiUrl);

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      console.log("get ageing statement:", data);
      onAgeingStatementDataFetched(data);
    } catch (err) {
      console.error("Error while getting ageing statement:", err);
    }
  };

  const viewPDFFile = async () => {
    //let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMStatement/${company_code_from_local_storage}/${statementToAPI}/${selectedAccountToAPI}/${selectedAccount2ToAPI}/-/${fromDate}/${toDate}/-/-`;

    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMStatementPdf/${company_code_from_local_storage}/${statementToAPI}/${selectedAccountToAPI}/-/-/${fromDate}/${toDate}/-/-/STATEMENT`;

    setIsCallingViewPDFAPI(true);

    const response = await fetch(apiUrl);
    const blob = await response.blob();

    setIsCallingViewPDFAPI(false);

    const pdfUrl = window.URL.createObjectURL(blob);
    window.open(pdfUrl, "_blank");
  };

  const downloadPDF = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMStatementPdf/${company_code_from_local_storage}/${statementToAPI}/${selectedAccountToAPI}/-/-/${fromDate}/${toDate}/-/-/STATEMENT`;

    try {
      setIsCallingDownloadPDFAPI(true);
      const response = await fetch(apiUrl, {
        method: "GET",
      });

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || "Failed to fetch report");
      }
      // Get PDF as Blob
      const blob = await response.blob();
      // Create download link
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `statement_${selectedAccountToAPI}.pdf`;
      link.click();
      window.URL.revokeObjectURL(link.href);
      setIsCallingDownloadPDFAPI(false);
    } catch (error) {
      setIsCallingDownloadPDFAPI(false);
      console.error("Error downloading PDF:", error);
      alert("Failed to download report");
    }
  };

  const viewPDFFileOutstanding = async () => {
    //let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMStatement/${company_code_from_local_storage}/${statementToAPI}/${selectedAccountToAPI}/${selectedAccount2ToAPI}/-/${fromDate}/${toDate}/-/-`;

    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMOutstandingPdf/${company_code_from_local_storage}/${outStatementToAPI}/${selectedAccountToAPI}/-/-/${fromDate}/${toDate}/-/-/OUTSTANDING`;

    setIsCallingViewPDFAPIOutstanding(true);

    const response = await fetch(apiUrl);
    const blob = await response.blob();

    setIsCallingViewPDFAPIOutstanding(false);

    const pdfUrl = window.URL.createObjectURL(blob);
    window.open(pdfUrl, "_blank");
  };

  const downloadPDFOutstanding = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMOutstandingPdf/${company_code_from_local_storage}/${outStatementToAPI}/${selectedAccountToAPI}/-/-/${fromDate}/${toDate}/-/-/OUTSTANDING`;

    try {
      setIsCallingDownloadPDFAPIOutstanding(true);
      const response = await fetch(apiUrl, {
        method: "GET",
      });

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || "Failed to fetch report");
      }
      // Get PDF as Blob
      const blob = await response.blob();
      // Create download link
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `statement_${selectedAccountToAPI}.pdf`;
      link.click();
      window.URL.revokeObjectURL(link.href);
      setIsCallingDownloadPDFAPIOutstanding(false);
    } catch (error) {
      setIsCallingDownloadPDFAPIOutstanding(false);
      console.error("Error downloading PDF:", error);
      alert("Failed to download report");
    }
  };

  return (
    <div>
      <div className="flex flex-col gap-2 bg-[#ECF6FE]   pb-[6px] pl-[8px] mb-4">
        {/* <div className="flex flex-col gap-2 bg-transparent py-[14px] pl-[8px] mb-4"> */}

        <span>
          <FormControlLabel
            control={
              <Switch
                checked={isGroup}
                onChange={(e) => {
                  const newValue = e.target.checked;
                  setIsGroup(newValue);
                  setStatementToAPI(newValue ? "STMT_GRP1" : "STMT_ACC1");
                  setOutStatementToAPI(newValue ? "OUT_GRP1" : "OUT_ACC1");
                  // setOutStatementToAPI(newValue ? "OUT_GRP1" : "OUT_ACC1");
                }}
              />
            }
            label="Group Mode"
            sx={{ marginLeft: "2px", marginTop: "2px" }}
          />
        </span>

        {/* Input  */}

        <div className="flex flex-col items-center justify-center gap-4 mt-2">
          {isGroup ? (
            <div className="flex flex-col items-center justify-center gap-4">
              {/* <Group1Selector accounts={accountList} />
              <Group2Selector accounts={accountList} /> */}
              <Group1Selector
                onSelectedAccountParent={selectedGroup1FromChild}
              />
              <Group2Selector
                onSelectedAccountParent={selectedGroup2FromChild}
              />
              {/* 
      <label className="flex items-center gap-2 text-sm font-medium">
        <input
          type="checkbox"
          checked={jobCodeChecked}
          onChange={(e) => setJobCodeChecked(e.target.checked)}
          className="w-4 h-4 accent-blue-500 rounded"
        />
        Job Code
      </label> */}
            </div>
          ) : (
            <div>
              {/* <AccountSelector accounts={accountList} /> */}
              <AccountSelector
                accounts={accountListFromAPI}
                // searchTerm={searchTerm}
                // setSearchTerm={setSearchTerm}
                searchAccountTerm={searchTerm}
                setSearchAccountTerm={setSearchTerm}
                value={value}
                setValue={setValue}
                onSelectedAccountParent={selectedAccountFromChild}
                onSelectedAccountNameParent={selectedAccountNameFromChild}
                onSelectedAccountPhoneParent={selectedAccountPhoneFromChild}
                initialAccountData={initialAccountData}
              // setSelectedAccountToAPI={setSelectedAccountToAPI}
              />
            </div>
          )}
        </div>
        {isGroup ? (
          <div className="bg-transparent border-b mx-2">
            {/* Header with Toggle Button */}
            <div
              className="flex justify-between items-center px-4 py-2 cursor-pointer"
              onClick={() => setIsOpen(!isOpen)}
            >
              <h2 className="text-sm font-normal">Detail Filters</h2>
              {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
            </div>

            {/* Collapsible Content */}
            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
                }`}
            >
              <div className="flex flex-wrap items-center gap-4 px-4 py-3">
                {/* Search Bar */}
                <div className="w-full  flex items-center justify-between">
                  <input
                    type="text"
                    placeholder="Search..."
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm 
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                  {/* </div> */}

                  {/* Job Code Checkbox */}
                  {/* <div className="flex items-center gap-2 text-sm font-medium ml-4 mr-2"> */}
                  <div className="flex justify-between items-center">
                    <input
                      type="checkbox"
                      checked={jobCodeChecked}
                      onChange={(e) => setJobCodeChecked(e.target.checked)}
                      className="w-4 h-4 mx-2 accent-blue-500 rounded"
                    />
                    <p className="text-[0.5rem]">Job Code</p>
                  </div>
                </div>

                {/* Department Select */}
                <select
                  value={deptCode}
                  onChange={(e) => setDeptCode(e.target.value)}
                  className="border border-gray-300 rounded-lg  px-3 py-2 text-sm w-full
               focus:ring-2 focus:ring-blue-500 focus:outline-none"
                >
                  <option value="">Select Dept</option>
                  {departmentList.map((dept, index) => (
                    <option key={index} value={dept.deptno}>
                      {dept.deptnodesc}
                    </option>
                  ))}
                </select>

                {/* Salesperson Select */}
                <select
                  value={salesperson}
                  onChange={(e) => setSalesperson(e.target.value)}
                  className="border border-gray-300 rounded-lg pl-3 py-2 w-full text-sm 
               focus:ring-2 focus:ring-blue-500 focus:outline-none"
                >
                  <option value="">Select Salesperson</option>
                  {salesPersonList.map((sperson, index) => (
                    <option key={index} value={sperson.EMP_ID}>
                      {sperson.NAME}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="flex items-center justify-between">
          <div className="" style={wrapperStyle}>
            <label className="font-thin text-xs">From Date</label>
            <DatePicker
              selected={
                fromDate && dayjs(fromDate).isValid()
                  ? new Date(fromDate)
                  : null
              }
              onChange={(date) =>
                setFromDate(date ? dayjs(date).format("YYYY-MM-DD") : null)
              }
              placeholderText="Choose from date"
              dateFormat="dd/MM/yyyy"
              customInput={<input style={inputStyle} />}
            />
            <CalendarTodayIcon style={iconStyle} />
          </div>
          <div style={wrapperStyle}>
            <label className="font-thin text-xs mr-4">To Date</label>
            <DatePicker
              selected={
                toDate && dayjs(toDate).isValid() ? new Date(toDate) : null
              }
              onChange={(date) =>
                setToDate(date ? dayjs(date).format("YYYY-MM-DD") : null)
              }
              placeholderText="Choose to date"
              dateFormat="dd/MM/yyyy"
              customInput={<input style={inputStyle} />}
            />
            <CalendarTodayIcon style={iconStyle} />
          </div>
        </div>
        {/* <div className="flex items-center justify-between">
          <div className="" style={wrapperStyle}>
            <label className="font-thin text-xs">From Date</label>
            <DatePicker
              // selected={fromDate}
              selected={fromDate ? new Date(fromDate) : null}
              // onChange={(date) => setFromDate(date)}
              onChange={(date) => setFromDate(dayjs(date).format("YYYY-MM-DD"))}
              placeholderText="Choose from date"
              dateFormat="dd/MM/yyyy"
              customInput={<input style={inputStyle} />}
            />
            <CalendarTodayIcon style={iconStyle} />
          </div>
          <div style={wrapperStyle}>
            <label className="font-thin text-xs mr-4">To Date</label>
            <DatePicker
              // selected={toDate}
              // onChange={(date) => setToDate(date)}
              selected={toDate ? new Date(toDate) : null}
              onChange={(date) => setToDate(dayjs(date).format("YYYY-MM-DD"))}
              placeholderText="Choose to date"
              dateFormat="dd/MM/yyyy"
              customInput={<input style={inputStyle} />}
            />
            <CalendarTodayIcon style={iconStyle} />
          </div>
        </div> */}
      </div>

      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        sx={{
          fontFamily: "'Figtree', sans-serif",
          backgroundColor: "#E7F5E9",
          borderRadius: "8px",
          border: "none",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            fontFamily: "'Figtree', sans-serif",
            backgroundColor: "#C3EFC5",
            borderRadius: "10px",
            padding: "8px 14px",
            marginTop: "10px",
            cursor: "pointer",
            transition: "all 0.25s ease-in-out",
            boxShadow: "0 4px 0 #8BC48F, 0 6px 12px rgba(0,0,0,0.15)",
            "&:hover": {
              backgroundColor: "#AEEAB2",
              transform: "translateY(-2px)",
              boxShadow: "0 6px 0 #78AD7B, 0 10px 16px rgba(0,0,0,0.2)",
            },
            "&:active": {
              backgroundColor: "#95D69C",
              transform: "translateY(2px)",
              boxShadow: "0 2px 0 #6A9F6D, 0 4px 8px rgba(0,0,0,0.15) inset",
            },
          }}
        >
          <span className="flex-shrink-0 flex justify-center items-center gap-2 font-normal">
            <FileText className="w-4 h-4 text-gray-900" />
            {isGroup ? "Group Account Statement" : "Account Statement"}
          </span>
        </AccordionSummary>

        <AccordionDetails
          sx={{ backgroundColor: "#E7F5E9", borderRadius: "18px" }}
        >
          {/* Checkboxes */}
          {/* <p className="text-sm mb-2">Statement to API: {statementToAPI}</p> */}
          <div className="grid grid-cols-2 gap-3 mt-4">
            {checkboxList.map((label) => (
              <div className="flex items-center gap-2" key={label}>
                <input
                  type="checkbox"
                  checked={!!checkedState[label]}
                  onChange={(e) =>
                    handleCheckboxChange(label, e.target.checked)
                  }
                  className="dark:border-white-400/20 dark:scale-100 transition-all duration-500 ease-in-out dark:hover:scale-110 dark:checked:scale-100 w-5 h-5 rounded-md"
                />
                <label className="text-sm">{label}</label>
              </div>
            ))}

            {/* <div class="dark:bg-black/10">
  <label class="text-white">
    <input class="dark:border-white-400/20 dark:scale-100 transition-all duration-500 ease-in-out dark:hover:scale-110 dark:checked:scale-100 w-10 h-10" type="checkbox">
  </label>
</div> */}

            {/* <FormControlLabel
  key={label}
  control={
    <Checkbox
      checked={!!checkedState[label]}
      onChange={(e) => handleCheckboxChange(label, e.target.checked)}
      sx={{
        '& .MuiSvgIcon-root': {
          borderRadius: '8px', // Rounds the checkbox corners
        },
      }}
    />
  }
  label={label}
  sx={{
    '& .MuiFormControlLabel-label': {
      fontSize: '0.875rem', // Reduces font size (e.g., 14px)
    },
  }}
/> */}

            {/* Toggle Switch */}
            <Box>
              <FormControlLabel
                control={<Switch />}
                label="FC On/Off"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "0.875rem", // Reduces font size (e.g., 14px)
                  },
                }}
              />
            </Box>
          </div>
          {/* Radio Buttons */}
          <div className="flex items-center justify-between my-2">
            <RadioGroup
              row
              defaultValue="all"
            //  onChange={handleAccountsModChange}
            >
              <FormControlLabel
                value="all"
                control={<Radio />}
                label="All"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "16px",
                  },
                }}
              />
              <FormControlLabel
                value="debit"
                control={<Radio />}
                label="Debit only"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "16px",
                  },
                }}
              />
              <FormControlLabel
                value="credit"
                control={<Radio />}
                label="Credit only"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "16px",
                  },
                }}
              />
            </RadioGroup>
          </div>

          <div >

            <div className="flex justify-between gap-2 items-center ">
              <button
                disabled={!selectedAccountToAPI}
                onClick={onShowStatement}
                className={`mt-2 w-40 text-white rounded-lg px-2 py-1 flex justify-center items-center gap-2
    ${!selectedAccountToAPI
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-blue-600 hover:bg-blue-700"
                  }`}
              >
                <FileText className="w-4 h-4" />
                Show
              </button>

              <button
                disabled={!selectedAccountToAPI}
                onClick={onPrintAccountStatement}
                className={`mt-2 w-40 text-white rounded-lg px-2 py-1 flex justify-center items-center gap-2
    ${!selectedAccountToAPI
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-green-600 hover:bg-green-700"
                  }`}
              >
                <Printer className="w-4 h-4" />
                Print
              </button>
            </div>

            <div className="flex justify-between gap-2 items-center ">
              <button
                disabled={!selectedAccountToAPI}
                onClick={downloadPDF}
                className={`mt-2 w-40 text-white rounded-lg px-2 py-1 flex justify-center items-center gap-2
    ${!selectedAccountToAPI
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-yellow-600 hover:bg-yellow-700"
                  }`}
              >
                {isCallingDownloadPDFAPI && (
                  <span>
                    <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
                  </span>
                )}
                <Download className="w-4 h-4" />
                Download
              </button>

              <button
                disabled={!selectedAccountToAPI}
                onClick={viewPDFFile}
                className={`mt-2 w-40 text-white rounded-lg px-2 py-1 flex justify-center items-center gap-2
    ${!selectedAccountToAPI
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-yellow-800 hover:bg-yellow-900"
                  }`}
              >
                {isCallingViewPDFAPI && (
                  <span>
                    <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
                  </span>
                )}
                <Eye className="w-4 h-4" />
                View
              </button>
            </div>

            {/* <div>
              <h3>Statement PDF</h3>
              <StatementPDFButton
                meta={sampleData.meta}
                account={sampleData.account}
                summary={sampleData.summary}
                transactions={sampleData.transactions}
                fileName="account-statement.pdf"
              />
            </div> */}
          </div>
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
        sx={{
          fontFamily: "'Figtree', sans-serif",
          backgroundColor: "#E7F5E9",
          borderRadius: "8px",
          border: "none",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          sx={{
            backgroundColor: "#F6E2C5",
            borderRadius: "10px",
            padding: "8px 14px",
            marginTop: "10px",
            cursor: "pointer",
            transition: "all 0.25s ease-in-out",
            // 3D shadow
            boxShadow: "0 4px 0 #D9B887, 0 6px 12px rgba(0,0,0,0.15)",
            "&:hover": {
              backgroundColor: "#f4d3a8",
              transform: "translateY(-2px)",
              boxShadow: "0 6px 0 #CDA76F, 0 10px 16px rgba(0,0,0,0.2)",
            },
            "&:active": {
              backgroundColor: "#e6b97f",
              transform: "translateY(2px)",
              boxShadow: "0 2px 0 #B9915E, 0 4px 8px rgba(0,0,0,0.15) inset",
            },
          }}
        >
          <span className="flex-shrink-0 flex justify-center items-center gap-2 font-normal text-gray-900">
            <Wallet className="w-4 h-4 text-gray-900" />
            {isGroup ? "Group Outstanding Statement" : "Outstanding Statement"}
          </span>
        </AccordionSummary>

        <AccordionDetails
          sx={{ backgroundColor: "#FCF0E2", borderRadius: "8px" }}
        >
          {/* <FormControlLabel
            control={
              <Switch
                checked={isGroupOutstanding}
                onChange={(e) => setIsGroupOutstanding(e.target.checked)}
              />
            }
            label="Group Mode"
            sx={{ marginLeft: "auto" }}
          /> */}
          {/* Checkboxes */}
          {/* <p className="text-sm mb-2">Statement to API: {outStatementToAPI}</p> */}

          <div className="grid grid-cols-2 gap-4 mt-4">
            {outstandingCheckboxList.map((label) => (
              // <FormControlLabel
              //   key={label}
              //   control={
              //     <Checkbox
              //       checked={!!outstandingCheckedState[label]}
              //       onChange={(e) =>
              //         handleOutstandingCheckboxChange(label, e.target.checked)
              //       }
              //     />
              //   }
              //   label={label}
              // />

              <div className="flex items-center gap-2" key={label}>
                <input
                  type="checkbox"
                  checked={!!outstandingCheckedState[label]}
                  onChange={(e) =>
                    handleOutstandingCheckboxChange(label, e.target.checked)
                  }
                  className="dark:border-white-400/20 dark:scale-100 transition-all duration-500 ease-in-out dark:hover:scale-110 dark:checked:scale-100 w-5 h-5 rounded-md"
                />
                <label className="text-sm">{label}</label>
              </div>
            ))}
          </div>

          {/* Toggle Switch */}
          <Box className="my-2">
            <FormControlLabel
              control={<Switch />}
              label="FC On/Off"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: "0.875rem", // Reduces font size (e.g., 14px)
                },
              }}
            />
          </Box>

          {/* Radio Buttons */}
          <Box>
            {/* <Typography variant="subtitle1" gutterBottom>
        Transaction Type
      </Typography> */}
            <RadioGroup row defaultValue="all">
              <FormControlLabel
                value="all"
                control={<Radio />}
                label="All"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "16px",
                  },
                }}
              />
              <FormControlLabel
                value="debit"
                control={<Radio />}
                label="Debit only"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "16px",
                  },
                }}
              />
              <FormControlLabel
                value="credit"
                control={<Radio />}
                label="Credit only"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "16px",
                  },
                }}
              />
            </RadioGroup>
          </Box>

          <div >

            <div className="flex justify-between gap-2 items-center ">
              <button
                disabled={!selectedAccountToAPI}
                onClick={onShowOutstandingStatement}
                className={`mt-2 w-40 text-white rounded-lg px-2 py-1 flex justify-center items-center gap-2
    ${!selectedAccountToAPI
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-blue-600 hover:bg-blue-700"
                  }`}
              >
                <FileText className="w-4 h-4" />
                Show
              </button>
              <button
                disabled={!selectedAccountToAPI}
                onClick={onPrintOutstandingStatement}
                className={`mt-2 w-40 text-white rounded-lg px-2 py-1 flex justify-center items-center gap-2
    ${!selectedAccountToAPI
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-green-600 hover:bg-green-700"
                  }`}
              >
                <Printer className="w-4 h-4" />
                Print
              </button>
            </div>

            <div className="flex justify-between gap-2 items-center ">
              <button
                disabled={!selectedAccountToAPI}
                onClick={downloadPDFOutstanding}
                className={`mt-2 w-40 text-white rounded-lg px-2 py-1 flex justify-center items-center gap-2
    ${!selectedAccountToAPI
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-yellow-600 hover:bg-yellow-700"
                  }`}
              >
                {isCallingDownloadPDFAPIOutstanding && (
                  <span>
                    <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
                  </span>
                )}
                <Download className="w-4 h-4" />
                Download
              </button>

              <button
                disabled={!selectedAccountToAPI}
                onClick={viewPDFFileOutstanding}
                className={`mt-2 w-40 text-white rounded-lg px-2 py-1 flex justify-center items-center gap-2
    ${!selectedAccountToAPI
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-yellow-800 hover:bg-yellow-900"
                  }`}
              >
                {isCallingViewPDFAPIOutstanding && (
                  <span>
                    <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
                  </span>
                )}
                <Eye className="w-4 h-4" />
                View
              </button>
            </div>

          </div>

        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
        sx={{
          fontFamily: "'Figtree', sans-serif",
          backgroundColor: "#E7F5E9",
          borderRadius: "8px",
          border: "none",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          sx={{
            backgroundColor: "#FFF076",
            borderRadius: "10px",
            padding: "8px 14px",
            marginTop: "10px",
            cursor: "pointer",
            transition: "all 0.25s ease-in-out",
            boxShadow: "0 4px 0 #E6D94D, 0 6px 12px rgba(0,0,0,0.15)", // 3D shadow
            "&:hover": {
              backgroundColor: "#FFD600", // hover
              transform: "translateY(-2px)",
              boxShadow: "0 6px 0 #D4BC00, 0 10px 16px rgba(0,0,0,0.2)",
            },
            "&:active": {
              backgroundColor: "#E6D93F", // pressed
              transform: "translateY(2px)",
              boxShadow: "0 2px 0 #BFA800, 0 4px 8px rgba(0,0,0,0.15) inset",
            },
          }}
        >
          <span className="flex-shrink-0 flex justify-center items-center gap-2 font-normal text-gray-900">
            <Clock className="w-4 h-4 text-gray-900" />
            {isGroup ? "Group Ageing Statement" : "Ageing Statement"}
          </span>
        </AccordionSummary>

        <AccordionDetails
          sx={{ backgroundColor: "#FDFAF2", borderRadius: "8px" }}
        >
          {/* <FormControlLabel
            control={
              <Switch
                checked={isGroupAgeing}
                onChange={(e) => setIsGroupAgeing(e.target.checked)}
              />
            }
            label="Group Mode"
            sx={{ marginLeft: "auto" }}
          /> */}
          {/* Checkboxes */}
          {/* <p className="text-sm mb-2">
            ageing Statement to API: {ageingStatementToAPI}
          </p> */}
          <h4 className="my-4 text-sm">Set Ageing Parameters</h4>
          <Box
            display="flex"
            flexDirection="row"
            gap={2}
            sx={{ maxWidth: 400 }}
          >
            {intervals.map((interval, index) => {
              const isInvalid = index > 0 && interval <= intervals[index - 1];

              return (
                <TextField
                  key={index}
                  // type="number"
                  label={`Days ${index + 1}`}
                  value={interval}
                  onChange={(e) => handleIntervalChange(index, e.target.value)}
                  size="small"
                  variant="standard"
                  fullWidth
                  error={isInvalid}
                  helperText={
                    index === 0
                      ? "Starting value"
                      : isInvalid
                        ? `Must be greater than ${intervals[index - 1]}`
                        : "Valid"
                  }
                  sx={{
                    "& .MuiInputLabel-root": {
                      fontFamily: "Figtree, sans-serif",
                    },
                    "& .MuiInputBase-input:focus": {
                      boxShadow: "none !important",
                    },
                  }}
                />
              );
            })}

            {/* <Button
        variant="contained"
        color="primary"
        onClick={generateApiUrl}
      >
        Generate API URL
      </Button> */}
          </Box>

          <div className="grid grid-cols-2 gap-4 my-4">
            {ageingCheckboxList.map((label) => (
              // <FormControlLabel
              //   key={label}
              //   control={
              //     <Checkbox
              //       checked={!!ageingCheckedState[label]}
              //       onChange={(e) =>
              //         handleAgeingCheckboxChange(label, e.target.checked)
              //       }
              //     />
              //   }
              //   label={label}
              // />

              <div className="flex items-center gap-2" key={label}>
                <input
                  type="checkbox"
                  checked={!!ageingCheckedState[label]}
                  onChange={(e) =>
                    handleAgeingCheckboxChange(label, e.target.checked)
                  }
                  className="dark:border-white-400/20 dark:scale-100 transition-all duration-500 ease-in-out dark:hover:scale-110 dark:checked:scale-100 w-5 h-5 rounded-md"
                />
                <label className="text-sm">{label}</label>
              </div>
            ))}
          </div>

          {/* Toggle Switch */}
          {/* <Box sx={{ mb: 2 }}>
            <FormControlLabel control={<Switch />} label="FC On/Off" />
          </Box> */}

          {/* Radio Buttons */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              flexWrap: "nowrap",
            }}
          >
            <RadioGroup
              row
              defaultValue="summary"
              onChange={handleAgeingModChange}
              sx={{ mr: 1 }}
            >
              <FormControlLabel
                value="summary"
                control={<Radio size="small" />}
                label="Summary"
                sx={{
                  mr: 1,
                  "& .MuiFormControlLabel-label": {
                    fontSize: "14px",
                  },
                }}
              />

              <FormControlLabel
                value="details"
                control={<Radio size="small" />}
                label="Details"
                sx={{
                  mr: 0,
                  "& .MuiFormControlLabel-label": {
                    fontSize: "14px",
                  },
                }}
              />
            </RadioGroup>

            {/* <FormControl size="small" sx={{ minWidth: 140 }}>
              <InputLabel size="small">Salesman</InputLabel>
              <Select
                label="Salesman"
                size="small"
                sx={{
                  height: 32,
                  fontSize: "14px",
                }}
              >
                <MenuItem value="-">All Salesmen</MenuItem>
                {salesPersonList?.length > 0 && salesPersonList.map((salesman) => (
                  <MenuItem key={salesman.EMP_ID} value={salesman.EMP_ID}>
                    {salesman.NAME}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
          </Box>

          <div className="flex justify-between gap-2 items-center ">
            <button
              disabled={!selectedAccountToAPI || ageingShowDisabled}
              onClick={onShowAgeingStatement}
              className={`mt-2 w-40 text-white rounded-lg px-2 py-1 flex justify-center items-center gap-2
    ${!selectedAccountToAPI || ageingShowDisabled
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
                }`}
            >
              <FileText className="w-4 h-4" />
              Show
            </button>
            <button
              onClick={onPrintAgeingStatement}
              disabled={!selectedAccountToAPI || ageingShowDisabled}
              className={`mt-2 w-40 text-white rounded-lg px-2 py-1 flex justify-center items-center gap-2
    ${!selectedAccountToAPI || ageingShowDisabled
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-green-600 hover:bg-green-700"
                }`}
            >
              <Printer className="w-4 h-4" />
              Print
            </button>
          </div>
        </AccordionDetails>
      </Accordion>
      {showStatementModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg w-[80vw] max-h-[90vh] overflow-y-auto p-4">
            <button
              onClick={handleCloseStatement}
              className="absolute top-3 right-3 text-gray-600 hover:text-black"
            >
              ✕
            </button>
            <StatementPreview
              statementDataFromAPI={statementData}
              statementDataRecordsFromAPI={statementDataRecords}
              handleCloseStatement={handleCloseStatement}
            />
          </div>
        </div>
      )}
      {showOutstandingModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg w-[80vw] max-h-[90vh] overflow-y-auto p-4">
            <button
              onClick={handleCloseStatement}
              className="absolute top-3 right-3 text-gray-600 hover:text-black"
            >
              ✕
            </button>
            <OutstandingPreview
              statementDataFromAPI={outstandingData}
              statementDataRecordsFromAPI={outstandingDataRecords}
              handleCloseStatement={handleCloseStatement}
            />
          </div>
        </div>
      )}

      {showStatementAgeingModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg w-[80vw] max-h-[90vh] overflow-y-auto p-4">
            {/* <button
        onClick={handleCloseStatement}
        className="absolute top-3 right-3 text-gray-600 hover:text-black"
        >
        ✕
      </button> */}
            <StatementAgeingPreview
              statementDataFromAPI={statementAgeingData}
              handleCloseStatement={handleCloseStatement}
            />
          </div>
        </div>
      )}
    </div>
  );
}
